var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo, useReducer, } from "react";
// The BEO main context
var BEO = createContext(undefined);
// Setting custom name for the context which is visible on react dev tools
BEO.displayName = "BEOContext";
// BEO reducer
function reducer(state, action) {
    switch (action.type) {
        case "THEME": {
            return __assign(__assign({}, state), { theme: action.value });
        }
        case "LAYOUT": {
            return __assign(__assign({}, state), { layout: action.value });
        }
        case "LOCALE": {
            return __assign(__assign({}, state), { locale: action.value });
        }
        case "TOKEN": {
            return __assign(__assign({}, state), { token: action.value });
        }
        case "REFRESH_TOKEN": {
            return __assign(__assign({}, state), { refreshToken: action.value });
        }
        case "USER_INFO": {
            return __assign(__assign({}, state), { userInfo: action.value });
        }
        default: {
            throw new Error("Unhandled action type");
        }
    }
}
// BEO Dashboard Primereact context provider
function BEOControllerProvider(_a) {
    var children = _a.children;
    var initialState = {
        theme: "lara-light-blue",
        layout: "dashboard",
        locale: "en",
        token: "",
        refreshToken: "",
    };
    var _b = useReducer(reducer, initialState), controller = _b[0], dispatch = _b[1];
    var value = useMemo(function () { return [controller, dispatch]; }, [controller]);
    return _jsx(BEO.Provider, { value: value, children: children });
}
// BEO Dashboard Primereact custom hook for using context
function useBEOController() {
    var context = useContext(BEO);
    if (!context) {
        throw new Error("useBEOController should be used inside the BEOControllerProvider.");
    }
    return context;
}
// Context module functions
var setLayout = function (dispatch, value) {
    return dispatch({ type: "LAYOUT", value: value });
};
var setMode = function (dispatch, value) {
    return dispatch({ type: "THEME", value: value });
};
var setGlobalLocale = function (dispatch, value) {
    return dispatch({ type: "LOCALE", value: value });
};
var setBearerToken = function (dispatch, value) {
    return dispatch({ type: "TOKEN", value: value });
};
var setRefreshToken = function (dispatch, value) {
    return dispatch({ type: "REFRESH_TOKEN", value: value });
};
var setUserInfo = function (dispatch, value) {
    return dispatch({ type: "USER_INFO", value: value });
};
export { BEOControllerProvider, setBearerToken, setGlobalLocale, setLayout, setMode, setRefreshToken, useBEOController, setUserInfo };
